import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import ReduxStoreInterface from '../../interfaces/client/ReduxStore'
import PassengerSSRDimensionsInterface from '../../interfaces/client/PassengerSSRDimensions'

import { dontShowLeaveAtGateOptionForSSRs } from '../../config/dontShowLeaveAtGateOptionForSSRs'

import getLabels from '../../utils/getLabels'
import generateUniqueId from '../../utils/generateUniqueId'
import getFormValuesWithoutRef from '../../utils/getFormValuesWithoutRef'

import { addPassengerSSR } from '../../actions/passengers'
import { closeSpecialSSRModal } from '../../actions/modals'

import AdditionalNotesForm from '../../components/AdditionalNotesForm'

export const mapStateToProps = (state: ReduxStoreInterface) => {
  const ssr = state.ssrs.byId[state.specialSSRModal.ssrId]
  const showLeaveAtGateOption = !dontShowLeaveAtGateOptionForSSRs.includes(
    ssr.id
  )
  const title = `${getLabels('ADD_DIMENSIONS_FOR', 'Add dimensions for')} ${
    ssr.name
  } (${ssr.name})`

  const passengerId = state.specialSSRModal.passengerId
  const passenger = state.passengers.byId[passengerId]
  const passengerName = passenger
    ? `${passenger.firstName} ${passenger.lastName}`
    : ''

  return {
    passengerId,
    ssr,
    showLeaveAtGateOption,
    title,
    passengerName,
  }
}

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  submitHandler: (elements: any, passengerId: string, ssrId: string) => {
    const passengerSSRId = `${ssrId}-${generateUniqueId()}`
    const formValues: PassengerSSRDimensionsInterface = getFormValuesWithoutRef(
      Array.from(elements)
    )

    const addPassengerSSROptions = {
      isConfirmed: false,
      isAbleToDelete: true,
    }

    dispatch(
      addPassengerSSR(
        passengerId,
        passengerSSRId,
        ssrId,
        addPassengerSSROptions,
        formValues
      )
    )
    dispatch(closeSpecialSSRModal())
  },

  cancelHandler: () => {
    dispatch(closeSpecialSSRModal())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdditionalNotesForm)
